module.exports = __webpack_public_path__ + "img/EmptyChat.917ef0d3.svg";